import { Col, Divider, Row, Avatar} from 'antd'
import Flex from 'components/Flex'
import {
  AddressNew,
  AndDivision,
  Condition,
  Container1,
  Content,
  Editor,
  EditorContent,
  ExtraPadding,
  FlexContain,
  FlexWrap,
  GrayText,
  GrayTextSmall,
  InfoText,
  LeftCol,
  Name1,
  PopHeading,
  PopHeading1,
  PopSubHeading,
  ShowDiv,
  ShowMoreText,
  SkillBox,
  SkillList,
  SubBold,
  SubtitleLarge,
  SubtitleMedium,
  SubtitleSmall,
  TitleMedium,
  VerticalDivider,
  VerticalDividerMax,
  YellowBox,
} from 'modules/ViewRole/Style/style'
import { toWords } from 'number-to-words'
import React, { useEffect, useRef, useState } from 'react'
import CandidatesIcon from '../../../components/icons/CandidatesIcon'
import AlarmOn from 'components/icons/Alarm_On'
import CalendarYellow from 'components/icons/CalendarYellow'
import Location from 'components/icons/LocationIcon'
import PaymentIcon from 'components/icons/PaymentIcon'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

import CustomTag from 'components/CustomTag'
import ConstructionIcon from 'components/icons/ConstructionIcon'
import CustomSteps from 'modules/ViewRole/Style/CustomSteps'
import Moment from 'moment'
import { formatNumber } from 'utils/formatNumber'
import { checkJobCategory } from '../../../utils/const'
const JobDescription = ({ viewRoleData, collegeData }) => {
  const numericToWords = number => {
    // Convert the numeric value to words
    const words = toWords(number)

    // Capitalize the first letter for consistency
    return words.charAt(0).toUpperCase() + words.slice(1)
  }
  let mandatorySkillNames = viewRoleData?.role?.mandatorySkillNames ?? null
  const hasNonEmptySkillSet = mandatorySkillNames?.otherSkillsNames?.some(
    (skillSet) => skillSet?.skillNames?.length > 0
  );
  const [completedStep, setCompletedStep] = useState()
  const [completStedepStatus, setCompletStedepStatus] = useState()
 

  useEffect(() => {
    if (viewRoleData?.role?.driveRoleCandidateMap) {
      let data = viewRoleData?.role?.driveRoleCandidateMap[0]?.stage
      setCompletStedepStatus(
        viewRoleData?.role?.driveRoleCandidateMap[0]?.status
      )
      let index = viewRoleData?.role?.interviewWorkFlow?.rounds?.findIndex(
        x => x.name === data
      )
      setCompletedStep(index)
    }
  }, [viewRoleData])

  const stepsData1 = viewRoleData?.role?.interviewWorkFlow?.rounds?.map(
    (round, index) => {
      return {
        key: index,
        activeKey: index,
        roundNumber: `Round ${index + 1}`,
        roundName: round?.name,
      }
    }
  )

  const checkDate = date => {
    return Moment(date).format('DD/MM/YYYY')
  }

  const checkJobTypeLevel = (data, YOE) => {
    const transformedData = data?.map(item => {
      switch (item) {
        case 'ENTRY':
          return ' Entry Level'
        case 'INTERN':
          return ' Internship'
        case 'EXPERIENCED':
          return YOE?.length > 0
            ? ` ${YOE[0]} - ${YOE[1]} Yrs Experience `
            : ` 0 - 1 Yrs Experience `
        default:
          return item
      }
    })

    return transformedData?.toString()
  }

  const groupedEducations = roleData => {
    let groupedDatas =
      roleData?.role?.degreeStreamMap?.reduce((acc, education) => {
        const degreeShortForm = education?.degree?.shortForm
        const streamName = education?.stream?.name

        if (!acc.hasOwnProperty(degreeShortForm)) {
          acc[degreeShortForm] = []
        }

        acc[degreeShortForm].push(streamName)

        return acc
      }, {})
    return groupedDatas
  }

  const renderContent = roleData => {
    let content = []
    if (groupedEducations(roleData)) {
      Object.entries(groupedEducations(roleData)).forEach(
        ([degree, streamNames]) => {
          content.push(
            <ExtraPadding key={degree}>
              <SubBold>{degree}</SubBold>
              <br />
              {streamNames.join(', ')}
              <br />
            </ExtraPadding>
          )
        }
      )
    }
    return content
  }

  const [expanded, setExpanded] = useState(false)

  const toggleExpanded = () => {
    setExpanded(!expanded)
  }

  const contentHeight = useRef(null)

  useEffect(() => {
    if (contentHeight.current && contentHeight.current.clientHeight > 250) {
      setExpanded(false)
    }
  }, [])

  function toCamelCase(str) {
    const words = str?.split(' ')
    const camelCaseWords = words?.map(word => {
      return word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
    })
    return camelCaseWords?.join(' ')
  }

  const [showAll, setShowAll] = useState(false)
  const totalIntegrations = viewRoleData?.eligibilityCriteria?.reduce(
    (count, item) => {
      return (
        count +
        item?.qualification?.reduce((subCount, qual) => {
          return (
            subCount +
            item?.selected?.[qual]?.reduce((subSubCount, subitem) => {
              return subitem.isAllDegree
                ? subSubCount
                : subSubCount +
                    (subitem?.streams?.reduce((streamCount, stream) => {
                      return (
                        streamCount + (stream?.specialisations?.length || 1)
                      )
                    }, 0) || 1)
            }, 0)
          )
        }, 0)
      )
    },
    0
  )

  const showItemCount = showAll ? totalIntegrations : 5

  let displayedIntegrations = 0
  console.log(showItemCount, displayedIntegrations)

  return (
    
      <Row>
        <LeftCol span={16}>
          <TitleMedium>{viewRoleData?.role?.tittle}</TitleMedium>

          <FlexContain centerVertically>
            <Avatar src={<AlarmOn />} />
            &nbsp;
            <AddressNew>
              {viewRoleData?.role?.rolePublishedBy == 'INSTITUTE'
                ? checkJobCategory(viewRoleData?.role?.jobCategory)
                : checkJobTypeLevel(
                    viewRoleData?.role?.jobTypeLevels,
                    viewRoleData?.role?.yearOfExperience
                  )}{' '}
              (
              {viewRoleData?.role?.jobType === 'FULL_TIME'
                ? 'Full Time'
                : 'Part Time'}
              )
            </AddressNew>
            <VerticalDivider type="vertical" />
            <Avatar src={<CandidatesIcon />} />
            &nbsp;
            <AddressNew>{`${viewRoleData?.role?.minVacancies} - ${viewRoleData?.role?.maxVacancies}`}</AddressNew>
            <VerticalDivider type="vertical" />
            <Avatar src={<PaymentIcon />} />
            &nbsp;
            <AddressNew>
              {viewRoleData?.role?.minCompensation !== undefined &&
                viewRoleData?.role?.maxCompensation !== undefined &&
                (viewRoleData.role.minCompensation ===
                viewRoleData.role.maxCompensation ? (
                  <span>
                    ₹ {formatNumber(Number(viewRoleData.role.minCompensation))}{' '}
                    ({numericToWords(viewRoleData.role.minCompensation)})
                  </span>
                ) : (
                  <span>
                    ₹ {formatNumber(Number(viewRoleData.role.minCompensation))}{' '}
                    ({numericToWords(viewRoleData.role.minCompensation)}) - ₹{' '}
                    {formatNumber(Number(viewRoleData.role.maxCompensation))} (
                    {numericToWords(viewRoleData.role.maxCompensation)})
                  </span>
                ))}{' '}
              {viewRoleData?.role?.CTCPeriod == 'ANNUALLY'
                ? 'Per annum'
                : viewRoleData?.role?.CTCPeriod == 'MONTHLY'
                ? 'Per month'
                : viewRoleData?.role?.CTCPeriod == 'WEEKLY'
                ? 'Per week'
                : viewRoleData?.role?.CTCPeriod == 'DAILY'
                ? 'Per day'
                : viewRoleData?.role?.CTCPeriod == 'HOURLY'
                ? 'Per hour'
                : ''}
            </AddressNew>
          </FlexContain>
          <FlexWrap gap="15px" centerVertically>
            <FlexWrap gap="5px" centerVertically>
              <div>
                <GrayTextSmall>Employment Type</GrayTextSmall>
                <FlexWrap wrap gap="5px">
                  <CustomTag
                    message={
                      viewRoleData?.role?.employmentType == 'ONROLL'
                        ? 'OnRoll'
                        : 'Contract'
                    }
                  />
                </FlexWrap>
              </div>
              {viewRoleData?.role?.jobDependency && (
                <>
                  <VerticalDividerMax type="vertical" />

                  <div>
                    <GrayTextSmall>Hiring Timeline</GrayTextSmall>
                    <FlexWrap wrap gap="5px">
                      <CustomTag message={viewRoleData?.role?.jobDependency} />
                    </FlexWrap>
                  </div>
                </>
              )}
            </FlexWrap>
          </FlexWrap>

          <Editor style={{ paddingLeft: '0px', paddingTop: '10px' }}>
            <EditorContent
              dangerouslySetInnerHTML={{
                __html: viewRoleData?.role?.description || '',
              }}
            />
          </Editor>
          {viewRoleData?.role?.interviewWorkFlow?.rounds?.length && (
            <SubtitleLarge color={COLORS.GREY_T_30}>
              Evaluation Process
            </SubtitleLarge>
          )}
          {viewRoleData?.role?.interviewWorkFlow?.rounds?.map((item, index) => (
            <div key={index+"round"}>
              <GrayTextSmall
                capitalize={true}
                marginbottom="10px"
                color={COLORS.GREY_T_30}
              >
                {`Round ${index + 1} - ${item?.name}`}
              </GrayTextSmall>
              <InfoText
                dangerouslySetInnerHTML={{
                  __html: item?.description || '',
                }}
              ></InfoText>
            </div>
          ))}
        </LeftCol>
        <Col span={8}>
          {viewRoleData?.isApplied === 1 &&
          viewRoleData?.role?.interviewWorkFlow?.rounds != undefined ? (
            <>
              <SubtitleMedium>Interview Stage & Status</SubtitleMedium>
              <Divider />
              <CustomSteps
                current={completedStep}
                currentStatus={completStedepStatus}
                steps={stepsData1}
              />
            </>
          ) : (
            <YellowBox>
              <CalendarYellow />
              <FlexWrap column>
                <GrayText fontweight={FONT.FW_400}>Last date to apply</GrayText>
                <SubtitleSmall fontweight={FONT.FW_600}>
                  {checkDate(viewRoleData?.role?.endDate)}
                </SubtitleSmall>
              </FlexWrap>
            </YellowBox>
          )}
          <Divider />
          <div>
            <FlexWrap gap="10px" centerVertically>
              <Location />
              <SubtitleMedium>Job Location</SubtitleMedium>
            </FlexWrap>

            <ul>
              {viewRoleData?.role?.isAnyWhere ? (
                <InfoText>
                  <li>Any where</li>
                </InfoText>
              ) : (
                viewRoleData?.role?.cities !== undefined &&
                viewRoleData?.role?.cities?.map((item, index) => (
                  <InfoText key={item.id}>
                    <li>{item.name}</li>
                  </InfoText>
                ))
              )}
            </ul>
          </div>
          {viewRoleData?.role?.isRemoteAllowed ? (
            <>
              <SubtitleSmall fontsize={FONT.XS}>
                We are also remote friendly
              </SubtitleSmall>
              <GrayText>Remote Location :</GrayText>
              {viewRoleData?.role?.remotCities !== undefined &&
                viewRoleData?.role?.remotCities.map((item, index) => (
                  <SubtitleSmall key={index+"remote"}> {item.name}</SubtitleSmall>
                ))}
            </>
          ) : null}
          <FlexWrap gap="10px"></FlexWrap>
          <br></br>
          <Flex>
            <Avatar size={20} src={<ConstructionIcon />} />
            &nbsp;&nbsp;
            <Name1>Eligibility Criteria </Name1>
          </Flex>
          {(mandatorySkillNames?.primarySkillNames?.skillNames?.length > 0 || mandatorySkillNames?.mandatorySkillNames?.length > 0 || mandatorySkillNames?.otherSkillsNames?.length > 0) && <div>
            <PopHeading>Mandatory Skills</PopHeading>
            <SkillList>
              <SubtitleSmall
                fontsize={FONT.XS}
                padding="4px"
                fontweight={FONT.FW_600}
              >
                <li>Primary Mandatory Skills</li>
              </SubtitleSmall>
              <FlexWrap wrap gap="5px" padding="5px 0px 0px 0px">
                {mandatorySkillNames?.primarySkillNames?.skillNames?.map(
                  (tag, index) => (
                    <>
                      <CustomTag
                        key={index+"primarySkillNames"}
                        message={tag.name}
                        marginright={'3px'}
                        background="#F0F2F4"
                      />
                      {mandatorySkillNames?.primarySkillNames?.skillNames
                        ?.length !=
                        index + 1 && (
                        <div>
                          <InfoText fontsize={FONT.SM}>
                            {mandatorySkillNames?.primarySkillNames?.type ==
                            'AND'
                              ? '&'
                              : 'OR'}
                          </InfoText>
                        </div>
                      )}
                    </>
                  )
                )}
              </FlexWrap>
              {mandatorySkillNames?.mandatorySkillNames?.length ? (
                <SubtitleSmall
                  fontsize={FONT.XS}
                  padding="4px"
                  fontweight={FONT.FW_600}
                >
                  <li>Secondary Mandatory Skills</li>
                </SubtitleSmall>
              ) : null}

              <FlexWrap wrap gap="5px" padding="5px 0px 0px 0px">
                {mandatorySkillNames?.mandatorySkillNames?.map((tag, index) => (
                  <>
                    <CustomTag
                      key={index+"mandatorySkillNames"}
                      message={tag.name}
                      marginright={'3px'}
                      background="#F0F2F4"
                    />
                    {mandatorySkillNames?.mandatorySkillNames?.length !=
                      index + 1 && (
                      <div>
                        <InfoText fontsize={FONT.SM}>,</InfoText>
                      </div>
                    )}
                  </>
                ))}
              </FlexWrap>
              {hasNonEmptySkillSet && mandatorySkillNames?.otherSkillsNames?.length ? (
                <SubtitleSmall
                  fontsize={FONT.XS}
                  padding="4px"
                  fontweight={FONT.FW_600}
                >
                  <li>Other Mandatory Skills</li>
                </SubtitleSmall>
              ) : null}
              {hasNonEmptySkillSet && <SkillList>
                {mandatorySkillNames?.otherSkillsNames?.map(
                  (skillSet, index) => (
                    <>
                      <SubtitleSmall
                        fontsize={FONT.XS}
                        fontweight={FONT.FW_500}
                        padding="4px"
                      >
                        <li>Skill Set {index + 1}</li>
                      </SubtitleSmall>
                      <FlexWrap wrap gap="5px">
                        {skillSet?.skillNames?.map((tag, index2) => (
                          <>
                            <CustomTag
                              key={index+"skillNames"}
                              message={tag.name}
                              marginright={'3px'}
                              background="#F0F2F4"
                            />
                            {skillSet?.skillNames?.length != index2 + 1 && (
                              <div>
                                <InfoText fontsize={FONT.SM}>
                                  {skillSet?.type == 'AND' ? '&' : 'OR'}
                                </InfoText>
                              </div>
                            )}
                          </>
                        ))}
                      </FlexWrap>
                    </>
                  )
                )}
              </SkillList>}
            </SkillList>
          </div>}
          {viewRoleData?.role?.optionalSkillsName?.length ? (
            <>
              <PopHeading>Good to Have Skills</PopHeading>
              <Flex wrap>
                {viewRoleData?.role?.optionalSkillsName?.map((tag, index) => (
                  <CustomTag
                    key={index+"optionalSkill"}
                    message={tag.name}
                    marginright={'3px'}
                    background="#F0F2F4"
                  />
                ))}
              </Flex>
            </>
          ) : null}
          <PopHeading>Gender</PopHeading>
          <PopSubHeading>
            {toCamelCase(viewRoleData?.role?.publishTo)}
          </PopSubHeading>
          {!!viewRoleData?.role?.degreeStreamMap?.length && (
            <>
              <PopHeading1>Degree & Department</PopHeading1>
              <Container1
                expanded={expanded}
                style={{
                  height:
                    contentHeight.current?.clientHeight < 250
                      ? 'auto'
                      : contentHeight.current?.clientHeight < 250 && '500px',
                }}
              >
                <Content ref={contentHeight}>
                  {renderContent(viewRoleData)}
                </Content>
              </Container1>
              {contentHeight.current?.clientHeight > 250 && (
                <ShowMoreText visible={!expanded} onClick={toggleExpanded}>
                  Show More...
                </ShowMoreText>
              )}
              {contentHeight.current?.clientHeight > 250 && expanded && (
                <ShowMoreText visible={expanded} onClick={toggleExpanded}>
                  Show Less
                </ShowMoreText>
              )}
            </>
          )}
          {viewRoleData?.role?.eligibilityCriteria?.length > 0 && (
            <Col xs={24}>
              <PopHeading1>Degree & Department</PopHeading1>
              <div style={{ marginTop: '10px' }}>
                <Content wrap="wrap" gap="10px" m>
                  {viewRoleData?.role?.eligibilityCriteria?.map((item, key) => {
                    if (displayedIntegrations >= showItemCount) return null

                    return (
                      <React.Fragment key={key + 'key'}>
                        {item.qualification?.map((qual, index) => (
                          <React.Fragment key={qual}>
                            {item?.selected?.[qual]?.[0]?.isAllDegree ? (
                              <SkillBox>
                                {' '}
                                Any{' '}
                                {[qual] == 'UG_DIPLOMA' ? 'DIPLOMA' : [qual]}
                              </SkillBox>
                            ) : (
                              <>
                                {' '}
                                {item?.selected?.[qual]?.map(
                                  (subitem, subkey) => {
                                    if (true) {
                                      return (
                                        <React.Fragment key={subkey + 'subKey'}>
                                          {subitem?.streams?.map(
                                            (stream, streamIndex) => (
                                              <React.Fragment
                                                key={
                                                  streamIndex + 'streamIndex'
                                                }
                                              >
                                                {stream?.specialisations
                                                  ?.length > 0
                                                  ? stream?.specialisations?.map(
                                                      (spec, specIndex) => {
                                                        if (
                                                          displayedIntegrations >=
                                                          showItemCount
                                                        )
                                                          return null

                                                        displayedIntegrations++
                                                        return (
                                                          <React.Fragment
                                                            key={
                                                              specIndex +
                                                              'specIndex'
                                                            }
                                                          >
                                                            <SkillBox>
                                                              {
                                                                subitem?.shortForm
                                                              }{' '}
                                                              - {stream?.name} -{' '}
                                                              {spec?.name}
                                                            </SkillBox>
                                                            {specIndex <
                                                              stream
                                                                .specialisations
                                                                .length -
                                                                1 &&
                                                              displayedIntegrations <
                                                                showItemCount && (
                                                                <Condition>
                                                                  Or
                                                                </Condition>
                                                              )}
                                                          </React.Fragment>
                                                        )
                                                      }
                                                    )
                                                  : displayedIntegrations++ <
                                                      showItemCount && (
                                                      <SkillBox
                                                        key={
                                                          streamIndex +
                                                          'streamIndex'
                                                        }
                                                      >
                                                        {subitem?.shortForm} -{' '}
                                                        {stream?.name}
                                                      </SkillBox>
                                                    )}
                                                {streamIndex <
                                                  subitem.streams.length - 1 &&
                                                  displayedIntegrations <
                                                    showItemCount && (
                                                    <Condition>Or</Condition>
                                                  )}
                                              </React.Fragment>
                                            )
                                          )}
                                          {subitem?.streams?.length === 0 &&
                                            displayedIntegrations++ <
                                              showItemCount && (
                                              <SkillBox key={subkey + 'sub'}>
                                                {subitem?.shortForm}
                                              </SkillBox>
                                            )}
                                          {subkey <
                                            item?.selected?.[qual]?.length -
                                              1 &&
                                            displayedIntegrations <
                                              showItemCount && (
                                              <Condition>Or</Condition>
                                            )}
                                        </React.Fragment>
                                      )
                                    }
                                  }
                                )}
                              </>
                            )}
                            {index < item.qualification.length - 1 && (
                              <Condition>Or</Condition>
                            )}
                          </React.Fragment>
                        ))}
                        {key <
                          viewRoleData?.role?.eligibilityCriteria.length -
                            1 && <AndDivision>And</AndDivision>}
                      </React.Fragment>
                    )
                  })}
                  {totalIntegrations > 5 && (
                    <ShowDiv onClick={() => setShowAll(!showAll)}>
                      {showAll ? 'Show Less' : 'Show More'}
                    </ShowDiv>
                  )}
                </Content>
              </div>
            </Col>
          )}
          <PopHeading>Year of passing</PopHeading>
          <PopSubHeading>
            {' '}
            {viewRoleData?.role?.yearOfPassing.join(', ')}
          </PopSubHeading>
          <PopHeading>Arrears / Backlogs</PopHeading>
          {!viewRoleData?.role?.isArrearsAllowed ? (
            <PopSubHeading>No Arrears / Backlogs allowed.</PopSubHeading>
          ) : (
            <PopSubHeading>
              Upto {viewRoleData.role?.arrearCount} Arrears / Backlogs allowed.
            </PopSubHeading>
          )}
          <PopHeading>Scores</PopHeading>
          <PopSubHeading>
            Average mark should be above {viewRoleData?.role?.avgScore}% in all
            your exams
          </PopSubHeading>
          <PopSubHeading>
            10th - Above {viewRoleData?.role?.tenthScore}%
          </PopSubHeading>
          <PopSubHeading>
            12th or Equivalent - Above {viewRoleData?.role?.twelfthScore}%
          </PopSubHeading>
          <PopSubHeading>
            UG - Above {viewRoleData?.role?.UGScore}%
          </PopSubHeading>
          <PopSubHeading>
            PG - Above {viewRoleData?.role?.PGScore}%
          </PopSubHeading>
          <Divider />
        </Col>
      </Row>
    
  )
}

export default JobDescription
